import NurseWorkQueue from "@/pages/nurse/NurseWorkQueue";

export default function SecretaryWorkQueue() {
  return <NurseWorkQueue audience="SECRETARIAT" />;
}
